import {Option} from "./Option";
import {ProductAndNumber} from "./ProductAndNumber";
import {MenuOrdered} from "./MenuOrdered";
export class BillElements {
	id: number;
	label: string;
	normalPrice: number;
	finalPrice: number;
	clientName: string;
	options: Array<Option>;
	productAndNumberList: Array<ProductAndNumber>;
	menuOrderedList: Array<MenuOrdered>;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/BillElement.ts